import { colors } from '../../colors';
var button = {
  //Hero button
  linkColorHero: colors.white,
  linkColorHeroHover: colors.white,
  backgroundColorHero: colors.coral,
  backgroundColorHoverHero: colors.rustRed,
  borderRadiusHero: '0',
  linkLineHeightHero: '30px',
  heroButtonPadding: '20px 35px',
  //primary button
  linkColorPrimary: colors.white,
  linkColorPrimaryHover: colors.white,
  backgroundColorPrimary: colors.coral,
  backgroundColorHoverPrimary: colors.rustRed,
  borderRadiusPrimary: '0',
  //secondary button
  linkColorSecondary: colors.white,
  backgroundColorSecondary: colors.coral,
  backgroundColorHoverSecondary: colors.rustRed,
  borderRadiusSecondary: '0',
  linkColorSecondaryHover: colors.white,
  borderColorSecondary: 'transparent',
  borderColorSecondaryHover: 'transparent'
};
export default button;